import { FC, useState } from "react";
import CustomButton from "ui/Button";
import { DATE_FORMAT, ICON_NAMES } from "utils/constant";
import { useTranslation } from "react-i18next";
import CustomDropDownList from "ui/dropDown";
import { getBuyersFilterApi } from "api/common";
import { SalesConfirmationFilter } from "api/salesConfirmation";
import DatePickerComponent from "ui/Date";
import { Vessel } from "interface/vessel";
import { VesselRenderItem } from "ui/dropdownItemList/VesselRenderItem";
import { getVesselFilter } from "api/vessel";
import { CustomNumberInput } from "ui/Input";

interface CustomProps {
	pageSize: number;
	setFilterOptions: (options: SalesConfirmationFilter) => void;
	filterOptions: SalesConfirmationFilter;
	exportAsPDF: () => void;
	exportAsExcel: () => void;
}
const Filter: FC<CustomProps> = ({
	setFilterOptions,
	filterOptions,
	exportAsPDF,
	...props
}) => {
	const { t } = useTranslation();
	const [tempFilter, setTempFilter] = useState<SalesConfirmationFilter>();

	const handleVessel = (vessel: Vessel) => {
		setFilterOptions({
			...filterOptions,
			vesselHullId: vessel.id as any,
			vesselId: vessel.id,
			vesselName: vessel.id ? vessel.nm : "",
			vesselLedgerAccountNumber: vessel.res?.toString(),
			take: props.pageSize,
			skip: 0,
		});
	};

	const applySalesNumber = () => {
		const newValue = tempFilter?.salesNumber || "";
		const currentValue = filterOptions.salesNumber || "";
		if (newValue === currentValue) return;
		setFilterOptions({
			...filterOptions,
			salesNumber: newValue,
			take: props.pageSize,
			skip: 0,
		});
	};

	const applyFromDate = () => {
		const newValue = tempFilter?.fromDate;
		if (newValue === filterOptions.fromDate) return;
		setFilterOptions({
			...filterOptions,
			fromDate: newValue,
			take: props.pageSize,
			skip: 0,
		});
	};

	const applyToDate = () => {
		const newValue = tempFilter?.toDate;
		if (newValue === filterOptions.toDate) return;
		setFilterOptions({
			...filterOptions,
			toDate: newValue,
			take: props.pageSize,
			skip: 0,
		});
	};

	return (
		<div className="filter-container">
			<div className="filter-items sales-confirmation-filter-items">
				<div className="sales-confirmation-filter-field" style={{ width: "170px" }}>
					<DatePickerComponent
						placeholder={t("FromDate")}
						label={t("FromDate")}
						format={DATE_FORMAT}
						className="height-inherit"
						style={{ width: "100%" }}
						value={tempFilter?.fromDate !== undefined ? tempFilter.fromDate : filterOptions.fromDate}
						onChange={(e) =>
							setTempFilter({ ...tempFilter, fromDate: e.target.value })
						}
						onBlur={() => applyFromDate()}
					/>
				</div>
				<div className="sales-confirmation-filter-field" style={{ width: "170px" }}>
					<DatePickerComponent
						placeholder={t("ToDate")}
						label={t("ToDate")}
						className="height-inherit"
						format={DATE_FORMAT}
						style={{ width: "100%" }}
						value={tempFilter?.toDate !== undefined ? tempFilter.toDate : filterOptions.toDate}
						onChange={(e) =>
							setTempFilter({ ...tempFilter, toDate: e.target.value })
						}
						onBlur={() => applyToDate()}
					/>
				</div>
				<div className="sales-confirmation-filter-field" style={{ width: "170px" }}>
					<CustomDropDownList
						data={[]}
						filterable={true}
						dataItemKey="id"
						textField="nm"
						label={t("Vessel")}
						value={{
							id: filterOptions.vesselId || null,
							nm: filterOptions.vesselName || " ",
						}}
						// label="Velg Fart�y"
						defaultItem={{ id: null, nm: t("All") }}
						onSelect={handleVessel}
						serverFilter={true}
						itemRender={VesselRenderItem()}
						serverFilterApi={getVesselFilter}
					/>
				</div>
				<div className="sales-confirmation-filter-field" style={{ width: "170px" }}>
					<CustomDropDownList
						onSelect={(buyer) =>
							setFilterOptions({
								...filterOptions,
								buyerId: buyer.id,
								buyerName: buyer.name,
								buyerLedgerAccountNumber: buyer.id,
								take: props.pageSize,
								skip: 0,
							})
						}
						data={[]}
						value={{
							id: filterOptions.buyerId || null,
							name: filterOptions.buyerName || " "
						}}
						dataItemKey="id"
						textField="name"
						label={t("Buyer")}
						defaultItem={{ id: null, name: t("All") }}
						className="height-inherit"
						filterable={true}
						serverFilter={true}
						serverFilterApi={getBuyersFilterApi}
					/>
				</div>
				<div className="sales-confirmation-filter-field" style={{ width: "170px" }}>
					<CustomNumberInput
						onChange={(e) => setTempFilter({ ...tempFilter, salesNumber: e })}
						label={t("SalesNumber")}
						placeholder=" "
						className="height-inherit"
						spinners={false}
						style={{ width: "100%" }}
						value={tempFilter?.salesNumber}
						onKeyDown={(e: any) => {
							if (e.key === "Enter") {
								applySalesNumber();
							}
						}}
						onBlur={(e) => {
							applySalesNumber();
						}}
					/>
				</div>
			</div>

			<div className="filter-end-btn sales-confirmation-filter-end-btn">
			{/*	<CustomButton*/}
			{/*		label={"PDF"}*/}
			{/*		onClick={() => exportAsPDF()}*/}
			{/*		iconName={ICON_NAMES.Download}*/}
			{/*	/>*/}
				<CustomButton
					label={"Excel"}
					onClick={() => props.exportAsExcel()}
					iconName={ICON_NAMES.Download}
				/>
			</div>
		</div>
	);
};

export default Filter;
